import React, {
  ReactNode,
  createContext,
  useContext,
  useState,
} from "react";


interface ViewContextProps {
  view: string;
  setView: Function ;
}

interface ViewProviderProps {
  children: ReactNode;
}

const ViewContext = createContext<ViewContextProps | undefined>(undefined);

const ViewProvider: React.FC<ViewProviderProps> = ({ children }) => {
  const [view, setView] = useState('card');

  return (
    <ViewContext.Provider value={{ setView ,view }}>{children}</ViewContext.Provider>
  );
};

export const useViewContext = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error("useViewContext must be used within a ViewProvider");
  }
  return context;
};

export default ViewProvider;
